import {create} from 'zustand';

export const useSubdomains = create(() => ({
    isSubdomainProcessing: true,
    isPresetExist: true,
    subdomainSettings: {}
  }));

